import fp from 'lodash/fp'
import _ from 'lodash'
import { createAction } from 'redux-actions'
import uuid from 'uuid'

const namespace = 'matches.matches'

export const types = {
  ADD: 'matches/matches/ADD',
  MERGE: 'matches/matches/MERGE',

  MARK_SYNC_STARTED: 'matches/matches/MARK_SYNC_STARTED',
  MARK_SYNC_FINISHED: 'matches/matches/MARK_SYNC_FINISHED',
  MARK_SYNC_FAILED: 'matches/matches/MARK_SYNC_FAILED',
  MARK_SYNC_SUCCEEDED: 'matches/matches/MARK_SYNC_SUCCEEDED',

  CLEAR: 'matches/matches/CLEAR',
  SET_TIMESTAMP: 'matches/matches/SET_TIMESTAMP'
}

export const actions = {
  add: createAction(types.ADD),
  merge: createAction(types.MERGE),

  markSyncStarted: createAction(types.MARK_SYNC_STARTED),
  markSyncFinished: createAction(types.MARK_SYNC_FINISHED),
  markSyncFailed: createAction(types.MARK_SYNC_FAILED),
  markSyncSucceeded: createAction(types.MARK_SYNC_SUCCEEDED),

  clear: createAction(types.CLEAR),
  setTimestamp: createAction(types.SET_TIMESTAMP)
}

function createSelectors () {
  const getMatches = fp.get(`${namespace}.items`)
  const getMatchFromFlightId = (flightId) => fp.flow(
    getMatches,
    fp.find(m => fp.includes(flightId, m.flightIds))
  )
  const getSyncStartedAt = fp.get(`${namespace}.syncStartedAt`)
  const getSyncFinishedAt = fp.get(`${namespace}.syncFinishedAt`)
  const getSyncFailedAt = fp.get(`${namespace}.syncFailedAt`)
  const getSyncSucceededAt = fp.get(`${namespace}.syncSucceededAt`)
  const getTimestamp = fp.getOr(0, `${namespace}.timestamp`)

  return {
    getMatches,
    getMatchFromFlightId,
    getSyncStartedAt,
    getSyncFinishedAt,
    getSyncFailedAt,
    getSyncSucceededAt,
    getTimestamp
  }
}

export const selectors = createSelectors()

export const initialState = {
  // {
  //   "01876b96-d0f8-436b-a851-31ffc87f29f5": {
  //     title: 'Some Title',
  //     createdAt: 1231553378,
  //     matchId: "01876b96-d0f8-436b-a851-31ffc87f29f5",
  //     flightIds: ['b26bbfae-2be5-447d-a173-53e6287a34ff']
  //   }
  // }
  items: {},
  syncStartedAt: null,
  syncFinishedAt: null,
  syncFailedAt: null,
  syncSucceededAt: null
}

const invalidAdd = fp.flow(
  fp.at(['title', 'flightIds']),
  fp.values,
  fp.some(fp.isNil)
)

export default function reducer (state = initialState, { payload, type } = {}) {
  switch (type) {
    case types.ADD:
      if (invalidAdd(payload)) {
        console.error('Invalid payload in \'matches/ADD\'')
        return state
      }
      return fp.set(`items.${payload.matchId || uuid.v4()}`, { ...payload, createdAt: Date.now() }, state)

    case types.MERGE:
      const { matches } = payload
      const localMatches = state.items
      const syncedMatches = _.reduce(matches, (acc, match) => {
        const matchKey = fp.get('matchId', match)
        if (fp.get(matchKey, acc)) {
          return acc
        }
        return fp.set(matchKey, match, acc)
      }, localMatches)
      return fp.set('items', syncedMatches, state)

    case types.MARK_SYNC_STARTED:
      return fp.flow(
        fp.set('syncStartedAt', Date.now()),
        fp.set('syncFailedAt', null)
      )(state)

    case types.MARK_SYNC_FINISHED:
      return fp.set('syncFinishedAt', Date.now(), state)

    case types.MARK_SYNC_FAILED:
      return fp.set('syncFailedAt', Date.now(), state)

    case types.MARK_SYNC_SUCCEEDED:
      return fp.set('syncSucceededAt', Date.now(), state)

    case types.SET_TIMESTAMP:
      return fp.set('timestamp', fp.getOr(0, 'timestamp', payload), state)

    case types.CLEAR:
      return initialState

    default:
      return state
  }
}
